export default "__VITE_ASSET__082d6340__"